import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { UserToken } from "../../domain/model/user-token";

@Injectable({
  providedIn: "root",
})
export class UserTokenWS {
  constructor(private handler: BaseHandler) {}
  execute(email: string, token: string): Observable<UserToken> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.GET_USER_TOKEN_ENDPOINT(email))
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.handler
      .execute(parameters)
      .pipe(map((response) => {
        return (response);
      }));
  }
}

